import api from "../../utils/ApiConfig";

export const fetchConsultationsData = async (page = 1, searchTerm = "", filters = {}) => {
  try {
    const response = await api.get(`/bo/rgpd-consultations`, {
      params: {
        page: page,
        per_page: 50,
        search: searchTerm,
        ...filters,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching consultations data:", error);
    throw error;
  }
};

export const fetchConsultationsStats = async (dateDebut = null, dateFin = null) => {
  try {
    const response = await api.get(`/bo/rgpd-consultations/stats`, {
      params: {
        date_debut: dateDebut,
        date_fin: dateFin,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching consultations stats:", error);
    throw error;
  }
};

export const exportConsultations = async (filters = {}) => {
  try {
    const response = await api.get(`/bo/rgpd-consultations/export`, {
      params: filters,
      responseType: 'blob',
    });

    // Créer un lien de téléchargement
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `consultations_rgpd_${new Date().toISOString().split('T')[0]}.csv`);
    document.body.appendChild(link);
    link.click();
    link.remove();

    return true;
  } catch (error) {
    console.error("Error exporting consultations:", error);
    throw error;
  }
};
